import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { SuRoleChangeUsersRequest } from "./SuRoleChangeUsersRequest";
import { SuRoleSchoolLevelRequest } from "./SuRoleSchoolLevelRequest";
import { RoleAdminSuReactivateStaffRequest } from "./RoleAdminSuReactivateStaffRequest";
import { IntListRequest } from "../../services/IntListRequest";
import { RoleAdminSuUsersAddRolesRequest } from "./RoleAdminSuUsersAddRolesRequest";

@Injectable()
export class DataService_RoleAdminSU {
	constructor(private httpclientService: HttpclientService) {}

	UsersSetActive(UserID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersSetActive?UserID=" + UserID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuSchoolRoleCountSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuSchoolRoleCountSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuSelectUserByRole(SchoolID, RoleID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuSelectUserByRole?SchoolID=" + SchoolID + "&RoleID=" + RoleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SuRoleRemoveUsers(parms: SuRoleChangeUsersRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SuRoleRemoveUsers";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SuRoleAddUsers(parms: SuRoleChangeUsersRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SuRoleAddUsers";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuUserDialogSelectList(SchoolID, RoleID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuUserDialogSelectList?SchoolID=" + SchoolID + "&RoleID=" + RoleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuDistrictUserSelectList() {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuDistrictUserSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuDistrictMakeSchoolLevel(parms: SuRoleSchoolLevelRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuDistrictMakeSchoolLevel";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuRoleListSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuRoleListSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuUserMultiSchoolSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuUserMultiSchoolSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuUserNoRolesSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuUserNoRolesSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuUserAssignedInactiveStaffSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuUserAssignedInactiveStaffSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuReactivateStaff(parms: RoleAdminSuReactivateStaffRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuReactivateStaff?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersDeleteMultiple(parms: IntListRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersDeleteMultiple?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleWithPagesGetList(UserLevelID, SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleWithPagesGetList?UserLevelID=" + UserLevelID + "&SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuUserAddRoles(parms: RoleAdminSuUsersAddRolesRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuUserAddRoles?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleAdminSuAssignToHomeSchoolOnly(parms: IntListRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleAdminSuAssignToHomeSchoolOnly?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
